export default function (data) {
  var dataStyle = {
    normal: {
      label: {
        show: true,
        color: "#fff",
        fontSize: 10,
      },
      labelLine: {
        //smooth: 0.2,
        length: 30,
        length2: 30,
      },
    },
  };
  var labelShow = {
    show: true,
    formatter: ["{d| {d}% }", "{b| {b} }"].join("\n"),
    rich: {
      d: {
        fontSize: 10,
        color: "#fff",
      },
      b: {
        fontSize: 10,
        color: "#fff",
      },
    },
  };
  return {
    backgroundColor: "rgba(0, 0, 0, 0)",
    grid: {
      top: "40",
      left: "10",
      right: "10",
      bottom: "10",
      containLabel: true,
    },
    tooltip: {
      trigger: "item",
      formatter: "{a} <br/>{b}: {c} ({d}%)",
    },
    legend: {
      show: false,
      orient: "vertical",
      x: "right",
      itemWidth: 14,
      itemHeight: 14,
      align: "left",

      data: [],
      textStyle: {
        color: "#fff",
      },
    },
    calculable: true,
    series: [
      {
        name: "",
        type: "pie",
        roseType: "area",
        radius: ["30%", "50%"],
        // radius: [55, 65],
        // center: ["50%", "50%"],
        itemStyle: dataStyle,
        color: [
          "rgb(170, 238, 255)",
          "rgb(121, 218, 255)",
          "rgb(0, 179, 255)",
          "rgb(36, 131, 255)",
          "#60a900",
          "#01949b",
          "#f17677",
        ],
        label: {
          normal: labelShow,
        },
        data: data,
      },
    ],
  };
}
